import { PHONES } from "./constants/phoneCode";

export function getDefaultPhoneCode(): string | undefined {
  if (typeof navigator === "undefined") return undefined;

  const localeStr = navigator.language;
  let iso: string | undefined;

  try {
    const locale = new Intl.Locale(localeStr);
    iso =
      locale.region ||
      (
        locale as Intl.Locale & { maximize?: () => { region?: string } }
      ).maximize?.()?.region;
  } catch {
    iso = localeStr.split("-")[1];
  }

  if (!iso) return undefined;

  const upperIso = iso.toUpperCase();
  return PHONES.find(p => p.iso === upperIso)?.code;
}
